import "./widgets-core17.css";
import { openBlock as n, createElementBlock as a, createElementVNode as o, defineComponent as c, useCssVars as l, unref as t, renderSlot as _, createVNode as u } from "vue";
import { u as d } from "./chunks/useTheme.L4REnSCw.js";
import { _ as i } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
function m(s, e) {
  return n(), a("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    o("path", { d: "M5 20a.5.5 0 01-.354-.853l8.646-8.646-8.646-8.646a.5.5 0 01.707-.707l9 9a.5.5 0 010 .707l-9 9a.498.498 0 01-.354.146z" })
  ]);
}
const p = {
  type: "button",
  class: "arrow-btn"
}, f = /* @__PURE__ */ c({
  __name: "ArrowBtn",
  setup(s) {
    l((r) => ({
      ac5ee68c: t(e).actionColor.base,
      c893b9b2: t(e).actionColor.washed
    }));
    const e = d();
    return (r, w) => (n(), a("button", p, [
      o("div", null, [
        _(r.$slots, "default", {}, void 0, !0)
      ]),
      o("div", null, [
        u(t(m), { class: "arrow-btn__icon" })
      ])
    ]));
  }
}), B = /* @__PURE__ */ i(f, [["__scopeId", "data-v-e98ad8fb"]]);
export {
  B as default
};
//# sourceMappingURL=widgets-core.es19.js.map
